import React from 'react';
import Image from 'next/image';
import Loader from 'public/images/loader.gif';

interface RouteLoaderProps {
  isLoading: boolean;
}

const RouteLoader: React.FC<RouteLoaderProps> = ({ isLoading }) => {
  // Don't render anything on server-side
  if (typeof window === 'undefined' || !isLoading) {
    return null;
  }

  // Use portal to render at document level to avoid z-index issues
  return (
    <div
      className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-[9999] transition-opacity duration-200"
      style={{ pointerEvents: 'auto' }}
      role="status"
      aria-label="Loading"
    >
      <div className="bg-white rounded-lg shadow-lg py-8 px-12 max-w-xs">
        <Image
          src={Loader}
          alt="Loading animation"
          width={120}
          height={120}
          className="object-contain mx-auto"
          priority
          unoptimized
        />
        <p className="text-center mt-4 text-black font-bold ">LOADING</p>
      </div>
    </div>
  );
};

export default RouteLoader;
